// Make an uploaded file's name safe as a GCS object name AND inside a raw
// (un-encoded) public URL.
//
// Why this matters: the object name the user picks flows, unchanged, into BOTH
// the GCS object path (via the resumable-upload URL) and the DB `url` the app
// stores (uploadVideo builds it from the same filePath). The source `url` is
// still built by bare string concatenation, so a filename containing '#', '?'
// or '%' produces a URL a browser mis-parses — a raw '#' becomes the fragment,
// the request 404s, and the video silently won't play/download. Names also
// sometimes arrive already percent-encoded (e.g. web-download names like
// "Foo%20Bar%23X.mp4"), which double-decode to a 404 too.
//
// This is the single, canonical replacement for the older inline
// `replaceAll(" ", "_")...` chains. It is a strict superset of that behaviour
// (still turns spaces into '_' and strips quotes) plus it neutralizes the
// URL/path hazards. Deterministic and idempotent, so re-uploading the same file
// yields the same name and de-duplication still matches.
export function sanitizeFileName(name) {
  let s = String(name == null ? '' : name);

  // Collapse a pre-encoded name to its real characters once (safely — a stray
  // '%' that isn't valid encoding throws and is left for the step below).
  try {
    s = decodeURIComponent(s);
  } catch (e) {
    /* malformed percent-encoding — the '%' is neutralized below */
  }

  s = s
    // URL/path hazards -> '_':
    //   '#' fragment, '?' query, '%' escape-sequence start,
    //   '/' '\' path separators / traversal, and control characters.
    .replace(/[#?%/\\\x00-\x1f\x7f]/g, '_')
    // existing behaviour preserved:
    .replace(/ /g, '_')
    .replace(/['"]/g, '');

  return s.length ? s : 'file';
}

export default sanitizeFileName;
